import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '@/features/analytics/index.ts'

export const Route = createFileRoute('/_authenticated/home/')({
  component: DashboardPage,
  head: () => ({ meta: [{ title: '业务看板 · Super Mega' }] })
})
